import { render, staticRenderFns } from "./SearchWeightProductForm.vue?vue&type=template&id=3d8990d6&scoped=true&"
import script from "./SearchWeightProductForm.vue?vue&type=script&lang=js&"
export * from "./SearchWeightProductForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchWeightProductForm.vue?vue&type=style&index=0&id=3d8990d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8990d6",
  null
  
)

export default component.exports